import React from 'react';
// import Header4 from './../Common/Header4';
import Header2 from '../Common/Header2';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import AboutusDetails from '../Elements/AboutusDetails';
// import Achievements1 from './../Elements/Achievements1';
// import Team2 from './../Elements/Team2';
// import Testimonials2 from './../Elements/Testimonials2';
import Services1 from '../Elements/Services1';
import ManagingPartner from '../Elements/ManagingPartner';
import Machineries from '../Elements/Machineries';

var bnrimg = require('./../../images/banner/5.jpg');

class AboutUs extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };
        loadScript('./assets/js/custom.js');
    };
    render() {
        return (
            <>
                <Header2 />
                <div className="page-content">
                    <Banner title="About Us" pagename="About 1" description="The company is committed to excellence in every aspect of its operations, striving to deliver projects that meet the highest standards of quality and efficiency." bgimage={bnrimg}/>
                    <AboutusDetails />
                    <Services1 />
                    <ManagingPartner />
                    <Machineries />
                    {/*<Achievements1 />
                     <Team2 />
                    <Testimonials2 separatoralignment="separator-center" /> */}
                </div>
                <Footer />
            </>
        );
    };
};

export default AboutUs;